
import { allCompleted as allCompletedAction } from "../actions";
export default function allCompleted(todos) {
    return async (dispatch) => {
        const requests = [];
        todos.forEach(todo => {
            if (!todo.completed) {
                requests.push(fetch(`http://localhost:9000/todos/${todo.id}`, {
                    method: "PATCH",
                    body: JSON.stringify({
                        completed: true,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                }))
            }
        })
        await Promise.all(requests)
        dispatch(allCompletedAction(todos));
    }
}